@let bot = config()?.bot;
@let live = config()?.live;
@let panel = config()?.panel;

@if (bot?.active || live?.active) {
    <div class="fixed right-4 bottom-0 left-4 z-(--z-chat)">
        @if (panel?.visible) {
            <div
                class="chat absolute right-0 bottom-0 flex flex-col overflow-hidden rounded-t-md bg-white"
                cdkDrag
                cdkDragLockAxis="x"
                cdkDragBoundary="html"
                [cdkDragDisabled]="!panel?.draggable"
                [class]="{
                    'draggable': panel?.draggable,
                    'minimized': panel?.minimized,
                }">
                <div class="inner flex flex-col">
                    <div
                        class="header flex items-center px-6 py-2"
                        cdkDragHandle>
                        <div class="me-auto flex items-center">
                            @if (panel?.viewMode !== viewModeEnum.chooseChat) {
                                <big-icon
                                    [icon]="panel?.viewMode === viewModeEnum.chatBot ? iconChatBot : iconUser"
                                    [size]="'w-10'"
                                    class="fill-primary mr-4 flex" />
                                <div>
                                    <span>
                                        {{
                                            panel?.viewMode === viewModeEnum.chatBot
                                                ? bot?.subtitle
                                                : live?.subtitle
                                        }}
                                        |
                                    </span>
                                    <span>
                                        <strong>
                                            {{
                                                panel?.viewMode === viewModeEnum.chatBot
                                                    ? bot?.title
                                                    : live?.title
                                            }}
                                        </strong>
                                    </span>
                                </div>
                            }
                        </div>
                        <button
                            (click)="toggleMinimize()"
                            type="button"
                            class="mr-6 p-1"
                            [class]="{ 'rotate-180': panel?.minimized }">
                            <big-icon
                                [icon]="iconAngleBottom"
                                [size]="'w-4'"
                                class="fill-primary" />
                            <span class="sr-only">{{ panel?.minimize }}</span>
                        </button>
                        <button
                            (click)="close()"
                            type="button"
                            class="p-1">
                            <big-icon
                                [icon]="iconClose"
                                [size]="'w-4'"
                                class="fill-primary" />
                            <span class="sr-only">{{ panel?.close }}</span>
                        </button>
                    </div>
                    <div class="bg-primary-100 relative flex-1 overflow-auto">
                        @if (panel?.viewMode === viewModeEnum.chooseChat) {
                            <div class="flex flex-col items-center justify-center p-4">
                                @if (live?.active) {
                                    <div class="mt-4 bg-white p-4 flex items-center flex-col rounded-md">
                                        <h4>{{ live?.title }}</h4>
                                        <p>{{ live?.intro }}</p>
                                        <big-ui-button
                                            [buttonStyle]="'primary'"
                                            (clicked)="setViewMode(viewModeEnum.liveChat)">
                                            <span>{{ live?.button }}</span>
                                        </big-ui-button>
                                    </div>
                                }
                                @if (bot?.active) {
                                    <div class="mt-4 bg-white p-4 flex items-center flex-col rounded-md">
                                        <h4>{{ bot?.title }}</h4>
                                        <p>{{ bot?.intro }}</p>
                                        <big-ui-button
                                            [buttonStyle]="'primary'"
                                            (clicked)="setViewMode(viewModeEnum.chatBot)">
                                            <span>{{ bot?.button }}</span>
                                        </big-ui-button>
                                    </div>
                                }
                            </div>
                        }
                        @if (panel?.viewMode === viewModeEnum.chatBot) {
                            <big-chat-bot (handover)="onHandover($event)" />
                        }
                        @if (panel?.viewMode === viewModeEnum.liveChat) {
                            <big-chat-live />
                        }
                    </div>
                </div>
            </div>
        }
    </div>
}
